import { jsxs, jsx } from 'react/jsx-runtime';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { homeReactTranslationRef } from '../translation.esm.js';

const SettingsModal = (props) => {
  const { open, close, componentName, children } = props;
  const { t } = useTranslationRef(homeReactTranslationRef);
  return /* @__PURE__ */ jsxs(Dialog, { open, onClose: () => close(), children: [
    /* @__PURE__ */ jsx(DialogTitle, { children: componentName ? `${t("settingsModal.title")} - ${componentName}` : t("settingsModal.title") }),
    /* @__PURE__ */ jsx(DialogContent, { children }),
    /* @__PURE__ */ jsx(DialogActions, { children: /* @__PURE__ */ jsx(Button, { onClick: () => close(), color: "primary", variant: "contained", children: t("settingsModal.closeButtonTitle") }) })
  ] });
};

export { SettingsModal };
//# sourceMappingURL=SettingsModal.esm.js.map
